import $$ from 'cmn-utils'

const baseUrl = "/api/sys/area/v2/";
export default {
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    // get: (params) => {
    //     return $$.get(baseUrl + 'get', params)
    // },
    listMap: (params) => {
        return $$.get(baseUrl + 'list-map', params)
    },
    tree: (params) => {
        return $$.get(baseUrl + 'tree', params)
    },
    areaTree: (params, map) => {
        let ret = new Promise(resolve => {
            $$.get(baseUrl + 'tree', params).then(value => {
                let treeArea = [];
                if (map) {
                    treeArea = [JSON.parse(
                        JSON.stringify(value)
                            .replace(/name/g, "title")
                            .replace(/code/g, "value")
                            .replace(/childrenList/g, "children")
                    )]
                } else {
                    treeArea = [JSON.parse(
                        JSON.stringify(value)
                            .replace(/name/g, "title")
                            .replace(/id/g, "value")
                            .replace(/childrenList/g, "children")
                    )]
                }
                resolve(treeArea);
            });
        })
        return ret;
    },
    update: (params) => {
        return $$.post(baseUrl + 'update', params)
    },

}

